export const DEFAULT_MARKET = 'us';

const MARKET_MATCHER = /^\/(int|[a-z]{2}|[a-z]{2}-[a-z]{2})(\/|$)/;

export const isMarketPresent = (path = ''): boolean => {
  const locationMarket = path.match(MARKET_MATCHER);
  return Boolean(locationMarket && locationMarket.length > 1 && locationMarket[1]);
};

// Happily borrowed from www-account-pages
export const extractMarket = (path = '') => {
  const locationMarket = path.match(MARKET_MATCHER);
  const market = locationMarket && locationMarket.length > 1 && locationMarket[1];
  return market || DEFAULT_MARKET;
};

export const pathWithoutMarket = (path: string) => {
  const market = extractMarket(path);
  return path
    .split('/')
    .filter(pathPart => pathPart !== market)
    .join('/');
};

// locales have the ${language}-${country} format e.g. `da-DK`
export const isEnglishSupportOnlyLocale = (locale: string, englishSupportOnlyLocales: Readonly<Array<string>>) => {
  if (!locale) {
    return true;
  }

  return englishSupportOnlyLocales.includes(locale);
};
